import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  FormControl
} from '@material-ui/core';
import { ImpressionBeaconList } from './ImpressionBeaconList';
import { ViewableImpressionBeaconList } from './ViewableImpressionBeaconList';
import { VideoBeaconList } from './VideoBeaconList';
import { useCreativeInput } from '../../../hooks';
import materialTheme from '../../../reactMaterialTheme';

const determineBeaconRequired = creative =>
  (creative.beacons || []).some(beacon => beacon.required);

export const BeaconFields = ({ creative, CreativeService }) => {
  const [localCreative, setCreative] = useState(creative);
  const creativeInputProps = useCreativeInput(
    ['runningInEu'],
    localCreative,
    setCreative,
    CreativeService
  );

  const [beaconRequired, setBeaconRequired] = useState(
    determineBeaconRequired(localCreative)
  );

  const handleBeaconRequiredChange = event => {
    setBeaconRequired(event.target.value == 'true');
  };

  return (
    <MuiThemeProvider theme={materialTheme}>
      <div>
        <FormControlLabel
          classes={{
            label: 'gdpr-fieldset_running-in-eu-label'
          }}
          control={
            <Checkbox
              name="runningInEu"
              checked={creativeInputProps.runningInEuProps.value}
              onChange={creativeInputProps.runningInEuProps.onChange}
            />
          }
          label="Creative is running in the EU"
        />
        {creativeInputProps.runningInEuProps.value && (
          <FormControl>
            <span className="gdpr-fieldset_beacon-action-label">
              For user opt-outs, do you want Sharethrough to not bid on the
              impressions or not fire the 3rd party tracker?
            </span>
            <RadioGroup
              value={beaconRequired.toString()}
              onChange={handleBeaconRequiredChange}
              row
            >
              <FormControlLabel
                value="true"
                control={<Radio classes={{ root: 'do-not-bid-radio' }} />}
                label="Do Not Bid"
              />
              <FormControlLabel
                value="false"
                control={<Radio classes={{ root: 'do-not-fire-radio' }} />}
                label="Do not fire beacon"
              />
            </RadioGroup>
          </FormControl>
        )}
      </div>

      <div className="form-group inline mt1">
        <ImpressionBeaconList
          creative={creative}
          CreativeService={CreativeService}
          beaconRequired={beaconRequired}
        />
        <ViewableImpressionBeaconList
          creative={creative}
          CreativeService={CreativeService}
          beaconRequired={beaconRequired}
        />
        {(creative.action === 'hosted-video' ||
          creative.action === 'native-outstream') && (
          <VideoBeaconList
            creative={creative}
            CreativeService={CreativeService}
            beaconRequired={beaconRequired}
          />
        )}
      </div>
    </MuiThemeProvider>
  );
};

BeaconFields.propTypes = {
  creative: PropTypes.shape({
    runningInEu: PropTypes.bool,
    action: PropTypes.string,
    beacons: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        event: PropTypes.string
      })
    )
  }).isRequired,
  CreativeService: PropTypes.shape({
    set: PropTypes.func.isRequired
  }).isRequired
};
